export function homePageScroll($: JQueryStatic): void {
    $(".homepage__scroll-btn-hero").on("click", function () {
        const heroHeight: number | null | undefined = $(".homepage__hero").innerHeight();

        $("html, body").animate(
            {
                scrollTop: heroHeight,
            },
            1500
        );
    });
}

export function shortlistRedirect($: JQueryStatic): void {
    $(".inline-shortlist-widget").on("click", function () {
        window.location.href = "/candidateshortlist";
    });
}

export function showValidationIfTrue($: JQueryStatic): void {
    $(".attrax-login-widget__btn-login").on("click", function () {
        if (
            $(".attrax-login-widget__validation-summary").children().length >= 1
        ) {
            $(".attrax-login-widget__validation-summary").css(
                "display",
                "block"
            );
        }
    });
}

export function removeFooterAutocomplete($: JQueryStatic): void {
    $(".footer__search .attrax-form-item__input").on("focus", function () {
        $(".autocomplete-suggestions").addClass("footer-focused");
    });

    $(".footer__search .attrax-form-item__input").on("blur", function () {
        setTimeout(() => {
            $(".autocomplete-suggestions").removeClass("footer-focused");
        }, 2000);
    });
}

export function displayNoSavedJobsMessage() {
    const shortlistPage = document.querySelector("body.page-candidate-shortlist");

    if (!shortlistPage) {
        return
    }
    const noJobsInShortlist = shortlistPage.querySelectorAll(".shortlisted-jobs.attrax-list-widget--no-items").length;

    if (noJobsInShortlist > 1) {
        shortlistPage.classList.add("page-candidate-shortlist--no-jobs");
    }
}

export function showExpiredVacancyBanner($: JQueryStatic): void {
    const isExpired = $("body.job-details .validation-summary-errors").length;

    if (isExpired >= 1) {
        $(".corp-expired-vacancy").addClass("show");
    }
}

export const addClearbtn = () => {
    const widgets: string[] = [
        "content-types-widget",
        "tags-widget",
        "attrax-post-filters",
    ];

    widgets.forEach((widget) => {
        if (document.querySelector(".post-results ." + widget)) {
            const widgetList: HTMLElement | null | undefined = document
                .querySelector(".post-results ." + widget)
                ?.querySelector("ul");
            const clearli: HTMLElement = document.createElement("li");
            clearli.classList.add(`${widget}__clear-btn-li`);
            const clearBTn: HTMLElement = document.createElement("a");
            clearBTn.classList.add(`${widget}__clear-btn`);
            clearBTn.classList.add(`btn`);
            clearBTn.setAttribute("href", "/posts");
            clearBTn.setAttribute(
                "aria-label",
                "click here to clear selected types"
            );
            clearBTn.textContent = "Clear";
            clearli.appendChild(clearBTn);
            widgetList?.appendChild(clearli);
        }
    });
};

export const removeNonBreakingSpaceFromJobDetails = () => {
    const jobDetails: HTMLDivElement | null = document.querySelector(
        ".job-details__main-content"
    );
    if (document.body.classList.contains("job-details") && jobDetails) {
        const emptyParagraphs: NodeListOf<HTMLParagraphElement> =
            jobDetails.querySelectorAll("p");
        emptyParagraphs.forEach((paragraph) => {
            if (paragraph.textContent && paragraph.textContent.length <= 1) {
                paragraph.remove();
            }
        });
    }
};

export const removeSocialWidgetIfEmpty = () => {
    const jobDetails: HTMLDivElement | null = document.querySelector(
        ".job-details__main-content"
    );

    if (document.body.classList.contains("job-details") && jobDetails) {
        const socialWidget: HTMLDivElement | null = jobDetails.querySelector('.social-hub-profile-widget');

        if (!socialWidget) return;

        socialWidget.childElementCount === 0 ? socialWidget.style.opacity = "0" : socialWidget.style.opacity = "1";
    }
};

export const addFilterTextHeadingJobResults = () => {
    if (!document.body.classList.contains("job-results")) return;

    const filterHeading: HTMLElement | null = document.querySelector("#filter-header");

    if (!filterHeading) return;

    if (window.innerWidth < 768) {
        filterHeading.innerHTML =
            "<span aria-label='mobilefilter toggle' role='button'>{{js.job-results-filter-heading}}</span>";

        filterHeading.style.opacity = "1";
    }
};

export const showAuthorDetailsIfAuthor = () => {
    const authorWidget: HTMLElement | null = document.querySelector(
        ".author-details-widget"
    );
    const page = document.querySelector(".post-details");

    if (!page || !authorWidget) return;

    const noAuthor = authorWidget.querySelector(".user-invisible");

    if (!noAuthor) {
        authorWidget.style.display = "block";
    }
};
